export default "__VITE_ASSET__BqSApXI8__"